import React from 'react';
import './CompanyHistory.css';

const CompanyHistory = () => {
  return (
    <section className="company-history-section section">
      <h2 className="section-title">About Us</h2>
      
      <div className="company-intro">
        <p>
          Global Business Combine was established with a vision to redefine precision tool manufacturing in India and beyond. 
          Our journey began over 30 years ago, and today, we are recognized as leaders in the field of tungsten carbide dies, 
          diamond tools, and specialty abrasives. Guided by our founder, Mr. Ramesh Gupta, we have always focused on quality, 
          innovation, and customer-centricity. Our state-of-the-art manufacturing facility and skilled workforce enable us to 
          deliver products that not only meet but exceed industry standards.
        </p>
        <p>
          At GBC, we believe in the power of technology and continuous improvement. We invest in the latest machinery, 
          rigorous quality control processes, and ongoing R&D to develop tools that cater to the evolving needs of our customers. 
          Our ISO 9001-2008 certification is a testament to our commitment to maintaining the highest standards in every aspect 
          of our business. From small-scale industries to large corporations, our products have empowered businesses to achieve 
          greater efficiency and precision.
        </p>
        {/* <p>
          From our foundation in the 1990s, through our growth and expansion in the 2000s, to achieving ISO 9001:2008 certification in 2008,
          GBC has consistently evolved to meet the changing needs of the industry. Our significant investments in technology during the 2010s
          have established us as market leaders in our field, and we continue to innovate into the 2020s, enhancing our R&D capabilities
          to develop tools that meet the evolving needs of both small-scale industries and large corporations.
        </p> */}
      </div>
      
    </section>
  );
};

export default CompanyHistory;
